/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { noop } from 'lodash';
import IconClose from 'mdi-material-ui/Close';
import IconMagnify from 'mdi-material-ui/Magnify';
import React from 'react';

interface ISearchInput {
  className?: string;
  value: string;
  placeholder?: string;
  onChange: (e: any) => void;
  onReset?: () => void;
  onFocus?: () => void;
  showResetButton?: boolean;
}

export const SearchInput = (props: ISearchInput) => {
  const {
    className,
    value,
    placeholder,
    onChange = noop,
    onReset = noop,
    onFocus = noop,
    showResetButton,
  } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      className={`${className} marapp-qa-searchbox`}
      variant="outlined"
      fullWidth={true}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onFocus={onFocus}
      InputProps={{
        className: 'marapp-qa-searchboxinput',
        startAdornment: (
          <InputAdornment position="start">
            <IconMagnify fontSize="large" />
          </InputAdornment>
        ),
        endAdornment: showResetButton ? (
          <InputAdornment position="start">
            <IconButton onClick={onReset} className="marapp-qa-searchboxclear" size="small">
              <IconClose fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};
